import adminThunkActions from "./adminThunk";

function createExtraReducers() {
  return {
    ...fileTypeListing(),
    ...verticalList(),
    ...reportFilterList(),
    ...entityTypeList(),
    ...roleList(),
    ...filterValueOptions(),
    ...childFilterValueOptions(),
    ...reportList(),
    ...globalRoleList(),
    ...userSearch(),
  };

  function fileTypeListing() {
    const { fulfilled, rejected } = adminThunkActions.fileUploadType;
    return {
      [fulfilled]: (state, action) => {
        state.fileUploadType.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.fileUploadType.error = action.payload;
      },
    };
  }
  function verticalList() {
    const { fulfilled, rejected } = adminThunkActions.verticalList;
    return {
      [fulfilled]: (state, action) => {
        state.verticalList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.verticalList.error = action.payload;
      },
    };
  }
  function reportFilterList() {
    const { fulfilled, rejected } = adminThunkActions.reportFilterList;
    return {
      [fulfilled]: (state, action) => {
        state.reportFilterList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportFilterList.error = action.payload;
      },
    };
  }
  function entityTypeList() {
    const { fulfilled, rejected } = adminThunkActions.entityTypeList;
    return {
      [fulfilled]: (state, action) => {
        state.entityTypeList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.entityTypeList.error = action.payload;
      },
    };
  }
  function userSearch() {
    const { fulfilled, rejected } = adminThunkActions.userSearch;
    return {
      [fulfilled]: (state, action) => {
        state.userSearch.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.userSearch.error = action.payload;
      },
    };
  }
  function reportList() {
    const { fulfilled, rejected } = adminThunkActions.reportList;
    return {
      [fulfilled]: (state, action) => {
        state.reportList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.reportList.error = action.payload;
      },
    };
  }
  function globalRoleList() {
    const { fulfilled, rejected } = adminThunkActions.globalRoleList;
    return {
      [fulfilled]: (state, action) => {
        state.globalRoleList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.globalRoleList.error = action.payload;
      },
    };
  }
  function roleList() {
    const { fulfilled, rejected } = adminThunkActions.roleList;
    return {
      [fulfilled]: (state, action) => {
        state.roleList.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.roleList.error = action.payload;
      },
    };
  }
  function filterValueOptions() {
    const { fulfilled, rejected } = adminThunkActions.filterValueOptions;
    return {
      [fulfilled]: (state, action) => {
        state.filterValueOptions.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.filterValueOptions.error = action.payload;
      },
    };
  }
  function childFilterValueOptions() {
    const { fulfilled, rejected } = adminThunkActions.childFilterValueOptions;
    return {
      [fulfilled]: (state, action) => {
        state.childFilterValueOptions.data = action.payload;
      },
      [rejected]: (state, action) => {
        state.childFilterValueOptions.error = action.payload;
      },
    };
  }
}

const adminExtraReducers = createExtraReducers();
export default adminExtraReducers;
